import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import * as LimitedPartnersEntityConfig from './EntityConfig';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as LimitedPartnersDashboardRoute } from '~/core/routes/limited-partners/_index';
import { Route as AliasMatchingRoute } from '~/core/routes/limited-partners/alias-matching/_index';
import { Route as LimitedPartnerCommitmentsRoute } from '~/core/routes/limited-partners/commitments/_index';
import { Route as LimitedPartnerDetailsRoute } from '~/core/routes/limited-partners/details/[limitedPartnerId]/_index';
import { Route as LimitedPartnerInsightsRoute } from '~/core/routes/limited-partners/insights/_index';
import { Route as LimitedPartnerReportBuilderRoute } from '~/core/routes/limited-partners/insights/report-builder/_index';
import { Route as AggregatedLimitedPartnersRoute } from '~/core/routes/limited-partners/partners/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={LimitedPartnersEntityConfig.permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /limited-partners/*
  children: [
    { index: true, element: <LimitedPartnersDashboardRoute /> },
    { path: 'alias-matching', element: <AliasMatchingRoute /> },
    { path: 'commitments', element: <LimitedPartnerCommitmentsRoute /> },
    { path: 'partners', element: <AggregatedLimitedPartnersRoute /> },
    { path: 'insights', element: <LimitedPartnerInsightsRoute /> },
    {
      path: 'insights/report-builder',
      element: <LimitedPartnerReportBuilderRoute />,
    },
    {
      path: 'details/:limitedPartnerId',
      element: <LimitedPartnerDetailsRoute />,
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
